/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VocabWordReviewItemDto = {
  /**
   * 단어 id
   */
  id: string;
  lemma: string;
  /**
   * 읽기(일본어)
   */
  reading: string | null;
  jlptLevel: VocabWordReviewItemDto.jlptLevel | null;
  /**
   * 한국어 뜻 — sense가 여럿이면 " / "로 연결
   */
  meaningKo: string;
  /**
   * 카테고리 key
   */
  topic: string | null;
  freqRank: number | null;
};
export namespace VocabWordReviewItemDto {
  export enum jlptLevel {
    N5 = "N5",
    N4 = "N4",
    N3 = "N3",
    N2 = "N2",
    N1 = "N1",
  }
}
